import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IUser } from '../shared/models/identity.models';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject: BehaviorSubject<IUser | null> = new BehaviorSubject<IUser | null>(null);

  constructor() { }

  setUser(user: IUser): void {
    this.userSubject.next(user);
  }

  getUser(): Observable<IUser | null> {
    return this.userSubject.asObservable();
  }

  getCurrentUser(): IUser | null {
    return this.userSubject.value;
  }
}
